import { Role } from "@/utils/api-client";
import myProjectRequestsRoutes from "../components/my-project-requests/router";
import myProjectsRoutes from "../components/my-projects/router";
import { Component } from "vue";

export default [
  {
    path: "my-projects",
    component: (): Promise<Component> =>
      import("../components/my-projects/MyProjects.vue"),
    children: myProjectsRoutes,
    meta: { role: Role.BORROWER },
  },
  {
    path: "my-project-requests",
    component: (): Promise<Component> =>
      import("../components/my-project-requests/MyProjectRequests.vue"),
    children: myProjectRequestsRoutes,
    meta: { role: Role.BORROWER },
  },
];
